






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CostPart, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'ordersApi'
  })
})
export default class DeleteCostPart extends Vue {
  private api!: WorkordersApi;

  @Prop({ required: true })
  private part!: CostPart;

  private deletePartPopoverTippy = false;
  private isLoading = false;

  async deletePart() {
    if (this.part.workorderId && this.part.costId) {
      this.isLoading = true;
      try {
        await this.api.deleteWorkOrderCostPart({
          workorderId: this.part.workorderId,
          costId: this.part.costId
        });
        this.deletePartPopoverTippy = false;
        this.isLoading = false;
        this.$emit('part-deleted');
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
}
